import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=43080dd6&scoped=true&"
import script from "./AccountData.vue?vue&type=script&lang=js&"
export * from "./AccountData.vue?vue&type=script&lang=js&"
import style0 from "./AccountData.vue?vue&type=style&index=0&id=43080dd6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43080dd6",
  null
  
)

export default component.exports